import React from "react";

const BlockConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  mode = "block",
  errorMessage,
}) => {
  if (!isOpen) return null;

  const isUnblock = mode === "unblock";

  return (
    <div className="blockConfirmModal__overlay">
      <div className="blockConfirmModal">
        <h2 className="blockConfirmModal__title">
          {isUnblock ? "ブロック解除の確認" : "ブロック確認"}
        </h2>
        <p className="blockConfirmModal__message">
          {isUnblock
            ? `${userName} のブロックを解除しますか？`
            : `${userName} をブロックしますか？`}
        </p>
        {!isUnblock && (
          <p className="blockConfirmModal__warning">
            このメンバーをブロックすると、互いにメッセージの送受信やプロフィールの閲覧ができなくなります。
          </p>
        )}
        {errorMessage && (
          <p className="blockConfirmModal__error" role="alert">
            {errorMessage}
          </p>
        )}
        <div className="blockConfirmModal__buttons">
          <button
            type="button"
            className="blockConfirmModal__cancel"
            onClick={onClose}
          >
            キャンセル
          </button>
          <button
            type="button"
            className="blockConfirmModal__confirm"
            onClick={onConfirm}
          >
            {isUnblock ? "解除する" : "ブロックする"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockConfirmModal;
